import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setDrawerOpen, setDrawerPage } from "../../../reducers/slices/main";
import { sign_out_thunk } from "../../../reducers/slices/user";
export function useAuthSidebarState() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { main } = useSelector((state) => state.mainState);
    const { user } = useSelector((state) => state.userState);
    const showAccount = useMemo(() => main.drawerPageName === "profile", [main.drawerPageName]);
    const handleCreateAccountClicked = useCallback(() => {
        dispatch(setDrawerPage("login"));
        dispatch(setDrawerOpen(false));
        navigate(`/auth/register`);
    }, []);
    const handleSigninClicked = useCallback(() => {
        dispatch(setDrawerPage("login"));
        dispatch(setDrawerOpen(false));
        navigate(`/auth/login`);
    }, []);
    const handleAccountDetailsClicked = useCallback(() => {
        dispatch(setDrawerPage("profile"));
        dispatch(setDrawerOpen(false));
        navigate(`/account-details`);
    }, []);
    const handleLogoutClicked = useCallback(() => {
        dispatch(sign_out_thunk());
        dispatch(setDrawerOpen(false));
        navigate(`/shop`);
    }, []);
    return useMemo(() => ({
        showAccount,
        handleCreateAccountClicked,
        handleSigninClicked,
        handleAccountDetailsClicked,
        handleLogoutClicked,
        user,
    }), [showAccount, handleCreateAccountClicked, handleSigninClicked, handleAccountDetailsClicked, handleLogoutClicked, user]);
}
